import { handleActions } from 'redux-actions';
import { SubmissionError } from 'redux-form';
import { LOCATION_CHANGE } from 'react-router-redux';

import cloneDeep from 'lodash/cloneDeep';
import forEach from 'lodash/forEach';
import pick from 'lodash/pick';

import http from '../../shared/http';
import endpoints from '../../../config/endpoints';
import intl from '../../shared/intl';

import { createSelectOptionsFromSysEnums, createSelectValuesUseIntersection } from '../../shared/form-elements/select';

// actions types
const FETCH_DATA_SUCCESS = 'admin-profile/fetch-data-success';
const FETCH_DATA_ERROR = 'admin-profile/fetch-data-error';

const SUBMIT_SUCCESS = 'admin-profile/submit-success';
const SUBMIT_ERROR = 'admin-profile/submit-error';

const UPLOAD_SUCCESS = 'admin-profile/upload-success';
const UPLOAD_ERROR = 'admin-profile/upload-error';
const PREPARATION_FILE_SUCCESS = 'admin-profile/preparation-file-success';

const TOGGLE_PROGRESS_BAR = 'admin-profile/toggle-progress-bar';

// initial state
const initialState = {
	data: null,
	form: {
		name: '',
		email: '',
		password: '',
		skype: '',
		telegram: '',
		timezone: null
	},
	fileToUpload: null,
	error: false,
	showProgressBar: false
};

// actions
export const actions = {
	fetchData: () => (dispatch, getState) => {
		http({
			url: endpoints.ADMIN_PROFILE,
			method: 'get',
			actions: [FETCH_DATA_SUCCESS, FETCH_DATA_ERROR]
		})(dispatch);
	},

	submitForm: formData => (dispatch, getState) => {
		const state = getState();
		const admin = state.adminProfile.data;

		const request = http({
			url: `${endpoints.ADMIN_PROFILE}/${admin.id}`,
			method: 'put',
			actions: [
				SUBMIT_SUCCESS,
				SUBMIT_ERROR
			],
			data: pick({
				...state.adminProfile.form,
				...formData,
				timezone: formData.timezone && formData.timezone[0] && formData.timezone[0].value || null
			}, Object.keys(state.adminProfile.form))
		});

		dispatch(actions.toggleProgressBar());

		return request(dispatch)
			.then(action => {
				if (action.type === SUBMIT_SUCCESS) {
					const id = admin.id;
					const fileToUpload = state.adminProfile.fileToUpload;

					if (fileToUpload) {
						actions.uploadFile(id, fileToUpload, dispatch);
					} else {
						dispatch(actions.fetchData());
					}
				}

				if (action.type === SUBMIT_ERROR && action.payload.response.status === 400) {
					dispatch(actions.toggleProgressBar());

					const validationsErrors = {};
					const responseErrors = action.payload.response.data;

					forEach(responseErrors, value => {
						const key = value.dataPath.slice(1);
						validationsErrors[key] = value.message;
					});

					throw new SubmissionError(validationsErrors);
				}
			});
	},

	uploadFile: (adminId, fileToUpload, dispatch) => {
		const request = http({
			url: `${endpoints.ADMINS_LIST}/${adminId}/avatar`,
			method: 'put',
			actions: [UPLOAD_SUCCESS, UPLOAD_ERROR],
			data: fileToUpload
		});

		request(dispatch).then(action => {
			if (action.type === UPLOAD_SUCCESS) {
				dispatch(actions.fetchData());
			}
		});
	},

	preparationFile: (file, nextAction) => dispatch => {
		const reader = new FileReader();
		const data = new FormData();

		data.append('avatar', file);

		reader.readAsDataURL(file);
		reader.onloadend = function() {
			nextAction(reader.result);
			dispatch({
				type: PREPARATION_FILE_SUCCESS,
				payload: data
			});
		};
	},

	toggleProgressBar: () => ({
		type: TOGGLE_PROGRESS_BAR
	}),

	timezonesLookup: text => (dispatch, getState) => {
		const timezones = (getState()).root.lists.timezones;
		const search = timezones.filter(item => text ? item.text.toLowerCase().indexOf(text.toLowerCase()) !== -1 : item);
		const options = createSelectOptionsFromSysEnums(search.slice(0, 4));
		return Promise.resolve({ options });
	}
};

// reducers
export default handleActions(
	{
		[LOCATION_CHANGE]: (state, action) => {
			if (action.payload.pathname === '/profile') {
				return {
					...state,
					data: null
				};
			}
			return state;
		},
		[FETCH_DATA_SUCCESS]: (state, action) => ({ ...state, data: action.payload.data, showProgressBar: false }),
		[FETCH_DATA_ERROR]: (state, action) => ({ ...state, error: true, showProgressBar: false }),
		[TOGGLE_PROGRESS_BAR]: state => ({ ...state, showProgressBar: !state.showProgressBar }),
		[PREPARATION_FILE_SUCCESS]: (state, action) => ({ ...state, fileToUpload: action.payload }),
		[UPLOAD_SUCCESS]: state => ({ ...state, fileToUpload: null }),
		[SUBMIT_ERROR]: (state, action) => {
			const { response: {status = null, data = null} } = action.payload;
			if (status === 400 && !!data) return state;
			return { ...state, error: true, showProgressBar: false };
		}
	},
	cloneDeep(initialState)
);

// selectors
export const selectors = {
	getData: state => {
		return state.adminProfile.data && {
			...state.adminProfile.data,
			timezone: createSelectValuesUseIntersection(
				createSelectOptionsFromSysEnums(state.root.lists.timezones),
				[state.adminProfile.data.timezone]
			)
		};
	},
	getTimezoneOptions: state => createSelectOptionsFromSysEnums(state.root.lists.timezones),
	getIntl: state => intl(state),
	getProgressBar: state => state.adminProfile.showProgressBar,
	getError: state => state.adminProfile.error
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/admins/profile/index.js